var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfileImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 515,
    height: 515,
    viewBox: "0 0 515 515",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 257.5,
    cy: 257.5,
    r: 257.5,
    fill: "#C6C6C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180 167.094C180 166.909 180.006 166.725 180.018 166.542C180.52 158.996 189.141 151.839 189.141 144.276V144.276C189.141 112.369 207.365 85 257.553 85C307.891 85 325.949 112.375 325.949 144.276V144.276C325.949 151.839 334.529 158.91 335.052 166.455C335.066 166.666 335.074 166.879 335.074 167.094V185.334V185.334C335.074 193.954 323.955 199.801 320.708 207.786C315.892 219.629 308.681 236.314 303.146 244.61C297.495 253.1 289.469 267.422 257.553 267.422C225.615 267.422 217.589 253.099 211.938 244.61C206.411 236.317 199.205 219.641 194.388 207.798C191.137 199.806 180 193.963 180 185.334V185.334V167.094ZM399.067 378.29C399.067 381.568 397.539 384.669 394.879 386.585C356.823 414 310.187 429.416 257.533 429.416C202.772 429.416 155.749 413.66 116.937 384.209C116.347 383.761 116.006 383.058 116.017 382.317L116.098 376.611C116.098 376.586 116.068 376.573 116.05 376.591V376.591C116.032 376.609 116.001 376.597 116.001 376.572C116.152 368.905 116.308 354.786 116.495 353.104C119.774 322.999 134.36 301.899 156.284 287.93C185.13 269.551 223.578 287.452 257.781 287.452V287.452V287.452C291.91 287.452 330.298 269.668 359.028 288.091C380.813 302.06 395.298 323.114 398.568 353.108C398.687 354.255 398.797 361.078 398.916 367.752C398.917 367.794 398.95 367.827 398.992 367.827V367.827C399.034 367.827 399.068 367.861 399.068 367.903L399.067 378.29Z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfileImage);
export default __webpack_public_path__ + "static/media/userProfileImage.47575fd24feb8a10e6bb81fe94bbceb9.svg";
export { ForwardRef as ReactComponent };